module.exports = __webpack_public_path__ + "static/img/A29.b536b0bc.jpg";